import { Component, Input, inject } from "@angular/core";
import { TabService } from "@services/tabs/TabService";
import { Pages } from "@constants/pages/Pages";
import { provideTranslocoScope } from "@jsverse/transloco";

@Component({
    selector: "moi-incident-summary",
    templateUrl: "./moi-incident-summary.component.html",
    styleUrls: ["./moi-incident-summary.component.scss"],
    standalone: false,
    providers: [provideTranslocoScope("moi")],
})
export class MoiIncidentSummaryComponent {
    private tabservice = inject(TabService);
    private pages = inject(Pages);

    @Input() summaryModel: any;
    @Input() incidentGuid: any;

    openIncident() {
        this.tabservice.generateTab(this.pages.IncidentDetail, this.incidentGuid);
    }
}
